<template>
  <div class="fc-content text-break">
    <va-popover
      v-if="appointment.type"
      :message="getAppointmentTypeLabel"
      placement="top"
      :popoverStyles="popoverStyles"
      :backgroundColor="appointment.type.color ? appointment.type.color : '#29c4a9'"
    >

      <AppointmentDisplay :appointment="appointment" />

    </va-popover>

    <AppointmentDisplay v-else :appointment="appointment" />

  </div>
</template>
<script>
import AppointmentDisplay from './AppointmentDisplay'
const DEFAULT_COLOR = '#29c4a9'
export default {
  components: {
    AppointmentDisplay
  },
  props: {
    view: {
      type: Object,
      required: true
    },
    event: {
      type: Object,
      required: true
    },
  },
  computed: {
    appointment: function () {
      return {
        ...this.event.extendedProps,
        start: this.event.start,
        end: this.event.end
      }
    },
    getAppointmentTypeLabel: function () {
      if (!this.appointment.type) return null
      let label = this.appointment.type.name
      if (this.appointment.type.slug && label !== this.appointment.type.slug) {
        label += ` (${this.appointment.type.slug})`
      }
      return label
    },
    popoverBackgroundColor: function () {
      return this.appointment.type && this.appointment.type.color ? this.appointment.type.color : DEFAULT_COLOR
    },
    popoverStyles: function () {
      return {
        color: 'white',
        'font-size': '0.8rem',
        'background-color': this.popoverBackgroundColor
      }
    }
  }
}
</script>
